module.exports = "<app-notes-list [notes]=\"notesArray\" [searchItem]=message ></app-notes-list>"